import React, { useState, useEffect } from "react";
import { Box, Typography, Divider, Button } from "@mui/material";
import Instagram from '../ImagesNew/ContactIcons/instagram.svg';
import LinkedIn from '../ImagesNew/ContactIcons/linkedIn.svg';
import Gmail from '../ImagesNew/ContactIcons/gmail.svg';
import CustomButton from "../shared/CustomButton";
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import './contact.css';

function Contact() {
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Function to update the width
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setTimeout(() => {
      setShowPopup(true);
      setFormData({ name: "", email: "", phone: "" });
      setTimeout(() => setShowPopup(false), 3000); // Hide popup after 3 seconds
    }, 1000); // Simulate a delay before showing the popup
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Box
      sx={{ width: "100%", backgroundColor: "transparent" }}
      id="Contact"
    >
        <CustomButton>
          <Typography variant='h6' sx={{fontFamily:'Crimson Text, serif'}}>Get In Touch</Typography>
        </CustomButton>
        <Box className={`flex ${width<850 ? 'flex-col' : 'flex-row'} justify-between mt-4 p-6 rounded-lg text-white bg-gray-700 w-full`}>
        <Box className={`${width<850 ? 'w-full' : 'w-2/5'} flex-col flex-wrap text-white`}>
        <Typography variant='h2' sx={{fontFamily:'Roboto, serif'}}>Let's <span className="text-gradient">Build</span> Together</Typography>
        <p className="font-sans text-base my-2" >Phone: <span className="text-gradient text-xl">+91 8688749458</span></p>
        <p className="font-sans text-base my-2" >Email: <span className="text-gradient text-xl">venkateshjnv123@gmail.com</span></p>
        <Box className="flex space-x-4 my-2">
          <InstagramIcon className="text-pink-600" sx={{width:'70px', height:'70px'}}/>
          <LinkedInIcon className="w-24 h-24 text-blue-600" sx={{width:'70px', height:'70px'}}/>
          <EmailIcon className="w-24 h-24 text-red-600" sx={{width:'70px', height:'70px'}}/>
        </Box>
        </Box>
  
      <Box
        id='box2'
        component="form"
        onSubmit={handleSubmit}
        className={`${width<850 ? 'w-full' : 'w-3/5'} flex flex-col justify-center`}
        noValidate
        autoComplete="off"
      >
        <Typography variant="p">
          Go ahead and say hello or send a proposal
        </Typography>
        <Divider />
        <div className="mb-4">
          <label htmlFor="name" className="block text-lg font-medium my-2">
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className="block w-full bg-transparent text-white py-1 border-b-2 focus:border-teal-400 focus:outline-none"
            placeholder="Enter your name"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block text-lg font-medium my-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className="block w-full bg-transparent text-white py-1 border-b-2 focus:border-teal-400 focus:outline-none"
            placeholder="Enter your email"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="phone" className="block text-lg font-medium my-2">
            Phone
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            className="block w-full bg-transparent text-white py-1 border-b-2 focus:border-teal-400 focus:outline-none"
            placeholder="Enter your phone number"
          />
        </div>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="w-fit p-2 text-white rounded-t-full rounded-br-full"
          style={{
            background:
              "linear-gradient(45deg, #56CCF2 30%, #2F80ED 90%)",
          }}
        >
          Submit
        </Button>
      </Box>
      </Box>

      {showPopup && (
        <Box
          className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50"
          onClick={() => setShowPopup(false)}
        >
          <Box className="bg-white p-6 rounded-lg text-center">
            <Typography variant="h5" className="mb-2">
              Yaay! Received your message, thank you!
            </Typography>
            <Button
              onClick={() => setShowPopup(false)}
              variant="contained"
              color="primary"
            >
              Close
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default Contact;
